import {theme} from '#theme';

import * as IconComponents from './Icon.component';

import {IconProps, IconSize} from './Icon.types';

const sizeMap: {[k in IconSize]: number} = {
  xSmall: 12,
  small: 16,
  normal: 20,
  24: 24,
  large: 32,
  40: 40,
  64: 64,
  74: 74,
};

export const Icon = ({
  ['aria-label']: ariaLabel,
  color: colorProp = 'black',
  name,
  size: sizeProp = 'normal',
  weight = 'bold',
  ...otherProps
}: IconProps) => {
  // The default `weight` prop value for any icons enclosed in a circle should
  // be 'fill'. Phosphor includes "Circle" as part of the name of any such icon.
  const weightFallback = name?.includes('Circle') ? 'fill' : undefined;
  const Component = IconComponents[name];
  const color = theme.colors[colorProp];
  const size = sizeMap[sizeProp];

  return Component ? (
    <Component
      aria-hidden={!ariaLabel ? true : false}
      aria-label={ariaLabel}
      color={color}
      size={size}
      weight={weight || weightFallback}
      {...otherProps}
    />
  ) : null;
};
